const formatDate = date => `${date.getFullYear()}-${(`0${date.getMonth() + 1}`).slice(-2)}-${(`0${date.getDate()}`).slice(-2)}`;
export default formatDate;

export const toStrDateTime = webix.Date.dateToStr('%d.%m.%Y %H:%i:%s');
